import React, { useEffect, useState } from "react";
import {
  TablePagination, Button, TableRow, Table, TableHead, TableBody,
  Typography, TableCell, Card, Box, Grid, Container,
  CardMedia, FormControl, InputLabel, Select,
  CardContent, CircularProgress, TextField,
  Chip,
} from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';
import SubjectService from "./Locality/Service/subjectService";
import {
  Dialog, DialogContent, IconButton,


  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  MenuItem
} from '@material-ui/core';
import {
  Star,
  CheckBox,
  FiberManualRecord,
  FormatListNumbered,
} from '@material-ui/icons';
import { useFormik } from 'formik';
//  import { useNavigate } from 'react-router-dom';
import { withStyles, makeStyles } from "@material-ui/core/styles";
import EventService from "./Locality/Service/eventService";
import LessonService from "./Locality/Service/lessonService";
import PageTitle from "../../components/PageTitle/PageTitle";
import Widget from "../../components/Widget/Widget";
import UserProfileCard from "./UserProfileCard";
import StudentCards from "./UserProfileCard";
import AddClassService from "./Locality/Service/addClassService";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#0f3b62ad",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
  tableOverflow: {
    overflow: "auto",
  },
  filterCard: {
    marginBottom: theme.spacing(4),
    padding: theme.spacing(3),
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
  },
  filterGrid: {
    margin: 0,
  },
  filterItem: {
    paddingTop: theme.spacing(1),
  },
  searchButton: {
    backgroundColor: "rgb(15 59 98)",
    color: "white",
    padding: theme.spacing(1.25, 2.5),
    textTransform: "uppercase",
    fontWeight: 600,
    borderRadius: 8,
    "&:hover": {
      backgroundColor: "rgb(12 45 75)",
    },
  },
  lessonGrid: {
    marginTop: theme.spacing(2),
  },
  lessonCardItem: {
    marginBottom: theme.spacing(3),
  },
  lessonCard: {
    borderRadius: 12,
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
    transition: "0.3s",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    "&:hover": {
      boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
    },
  },
  lessonCardContent: {
    padding: theme.spacing(2.5),
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
  },
  chipWrapper: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
  },
  lessonTitle: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
    fontWeight: 600,
    lineHeight: 1.3,
  },
  watchVideoBtn: {
    marginTop: theme.spacing(2),
    backgroundColor: "#0f3b629e",
    color: "white",
    padding: theme.spacing(1, 2),
    borderRadius: 8,
    textTransform: "uppercase",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "#0f3b62",
    },
  },
  resultsSection: {
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(1),
  },
}));

export default function TeacherLesson(props) {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);
  const [studentList, setStudentList] = useState([]);
  const [lessonList, setLessonList] = useState([]);
  const [dropDownList, setDropDownList] = useState([]);
  const [addClassList, setAddClassList] = useState([]);

  var [classId, setClassId] = useState("");
  const [selectedSubjectId, setSelectedSubjectId] = useState("");
  const [selectedLessonId, setSelectedLessonId] = useState("");
  var [error, setError] = useState(null);
  const [lessons, setLessons] = useState([]);
  const [showlessons, setShowLessons] = useState(false);
  const [tempLessons, setTemplLessons] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [subjectList, setSubjectList] = useState([]);
  const [openImage, setOpenImage] = useState(null);

  const [selectedData, setSelectedData] = useState({
    _id: "",
    lesson: "",
    subjectId: '',
    pointOfInterest: [],
    stepsAndProcedures: [],
    controlOfError: [],
    materialRequired: [],
    objectives: []
  });


  // const navigate = useNavigate();


  useEffect(() => {
    //getLessonList();
    getSubjectList();
    getAddClassList();
    //getLessonLists();
    return () => {
      setLessons([]);
      setSubjectList([]);
      // setLessonss([]);

    }
  }, []);
    const getAddClassList = (event) => {
          const userDetails = JSON.parse(localStorage.getItem("userDetail"));
          AddClassService.getAllAddClass(userDetails.schooleId).then((res) => {
              // if (userDetails.role === "TEACHER") {
              //     res = res.filter(res => res._id === userDetails.classId);
              // }
              setAddClassList(res);
              if (userDetails.classId) {
                setClassId(userDetails.classId);
              } else {
                setClassId(""); // No default selection
              }
          }).catch((err) => {
              // setError(err.message);
          });
      }
  const resetSearch = () => {
    setLessons(tempLessons);
    setDropDownList(tempLessons);
    setSelectedSubjectId("");
    setSelectedLessonId("");
  }
  const handleSearch = () => {
    const results = tempLessons.filter((lesson) => {
      const matchesSubject = selectedSubjectId
        ? lesson.subjectId?._id === selectedSubjectId
        : true;

      const matchesLesson = selectedLessonId
        ? lesson._id?.toLowerCase().includes(selectedLessonId.toLowerCase())
        : true;

      return matchesSubject && matchesLesson;
    });
    setShowLessons(true);
    setLessons(results);
  };



  const getSubjectList = (event) => {
    const userDetails = JSON.parse(localStorage.getItem("userDetail"));
    SubjectService.getAllSubject().then((res) => {

      setSubjectList(res);
    }).catch((err) => {
      // setError(err.message);
    });
  }
  const getLessonList = (subjectId = null, classId = null) => {
    const body = {};
    if (subjectId) {
      body.subjectId = subjectId;
    }
    if (classId) {
      body.classId = classId;
    }

    LessonService.findLessonList(body).then((res) => {
      setLessons(res);
      setTemplLessons(res);
      setDropDownList(res);
    }).catch((err) => {
      setError(err.message);
    });
  }

  const onChangeClass = (subjectId) => {
    setSelectedSubjectId(subjectId);
    
    // Call getLessonList with subjectId when subject changes
    getLessonList(subjectId, classId);


  }

  // const handleLearnMore = () => {
  //   //navigate(`/lessonmore/${lesson._id}`);
  // };
  const handleLearnMore = () => {
    props.history.push('/app/learnmore')
  };
  return (
    <>
      <PageTitle title="Lesson plan " />





      {/* </Grid> */}
      <Card className={classes.filterCard}>
        <Box className={classes.filterGrid} component="div" pt={1}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} sm={6} md={3} className={classes.filterItem}>
              <FormControl className={classes.formControl}  fullWidth="true"
              >
                <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="classId"
                  label="selectClass"


                  onChange={e => { setClassId(e.target.value) }}
                  value={classId}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>

                  {addClassList.map(({ _id, className }) => (
                    <MenuItem key={_id} value={_id}>{className}

                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3} className={classes.filterItem}>
              <FormControl className={classes.formControl} fullWidth
              >
                <InputLabel id="demo-simple-select-label">Select Subject</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  name="subjectId"
                  label="selectClass"
                  value={selectedSubjectId}
                  onChange={(e) => onChangeClass(e.target.value)}

                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>

                  {subjectList.map(({ _id, subject }) => (
                    <MenuItem key={_id} value={_id}>{subject}

                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={4} md={3}  >
              <FormControl variant="standard" fullWidth>
                <InputLabel id="studentName">Lesson</InputLabel>
                <Select
                  labelId="lesson"
                  id="lesson"
                  label="lesson Name"

                  name="lessonId"
                  value={selectedLessonId}
                  onChange={(e) => setSelectedLessonId(e.target.value)}

                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {dropDownList.map(({ index, _id, lesson }) => (
                    <MenuItem key={index} value={_id}>{lesson}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={2} className={classes.filterItem}>
              <Button
                className={classes.searchButton}
                type="button"
                onClick={handleSearch}
                variant="contained"
              >
                Search
              </Button>
            </Grid>
            {/* <Grid item xs={6} sm={4} md={2}>
              <Button style={{ backgroundColor: 'rgb(83 109 254)', color: 'white' }}
                type="button"

                onClick={resetSearch}
                variant="contained"
              >
                Reset</Button>
            </Grid> */}
          </Grid>



        </Box>
      </Card>
      <br></br>

      <br></br>
      <Container sx={{ py: 5 }}>



        <Grid container spacing={4} className={classes.lessonGrid}>
          {showlessons && lessons
            .filter((lesson) =>
              lesson.lesson.toLowerCase().includes(searchTerm.toLowerCase())
            )
            .map((lesson) => {
              const {
                _id,
                images,
                lesson: title,
                objectives,
                video,
                subjectId,
                classId,
                remarks,
                materialRequired
              } = lesson;
              const isSelected = selectedData._id === _id;

              return (
                <Grid item xs={12} sm={6} md={4} key={_id} className={classes.lessonCardItem}>
                  <Card
                    className={classes.lessonCard}
                    onClick={() => setSelectedData(lesson)}
                    style={{
                      boxShadow: isSelected ? '0 6px 20px rgba(25, 118, 210, 0.25)' : undefined,
                      border: isSelected ? '2px solid #1976d2' : '1px solid #e0e0e0',
                      cursor: 'pointer',
                      backgroundColor: isSelected ? '#e3f2fd' : '#fff',
                    }}
                  >
                    <CardContent className={classes.lessonCardContent}>
                      <Box className={classes.chipWrapper}>
                        <Chip
                          label={classId?.className || "N/A"}
                          color="primary"
                          size="small"
                        />
                        <Chip
                          label={subjectId?.subject || "N/A"}
                          size="small"
                          style={{
                            backgroundColor: '#e3f2fd',
                            color: '#0d47a1',
                            fontWeight: 600,
                            fontSize: '0.75rem',
                          }}
                          icon={<span role="img" aria-label="subject">📚</span>}
                        />
                      </Box>

                      <Typography variant="h6" className={classes.lessonTitle}>
                        {title.toUpperCase() || "Untitled Lesson"}
                      </Typography>




                      {video && (
                        <Button
                          className={classes.watchVideoBtn}
                          variant="contained"
                          size="small"
                            href={video}
                            target="_blank"
                            rel="noopener noreferrer"
                          fullWidth
                        >
                          WATCH VIDEO
                        </Button>
                      )}
                    </CardContent>
                  </Card>

                </Grid>
              );
            })}
        </Grid>
        <Box p={2}>
          <Typography variant="h6">{selectedData?.lesson.toUpperCase()}</Typography>
          {selectedData._id ? <>
            <Card style={{ marginBottom: 16 }}>
              <CardContent>
                <Typography variant="h6">🎯 Objectives / Aims</Typography>
                <List dense>
                  {selectedData.objectives.map((step, index) => (
                    <ListItem key={index} alignItems="flex-start">
                      <ListItemIcon>
                        <FiberManualRecord fontSize="small" color="primary" />
                      </ListItemIcon>
                      <ListItemText primary={step} />
                    </ListItem>
                  ))}
                </List>
              </CardContent>

            </Card>


            <Grid container spacing={2}>
              {/* Materials Section */}
              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6">📦 Materials</Typography>
                    <List dense>
                      {selectedData.materialRequired.map((step, index) => (
                        <ListItem key={index}>
                          <ListItemIcon>
                            <CheckBox color="primary" />
                          </ListItemIcon>
                          <ListItemText
                            primary={step}
                            primaryTypographyProps={{
                              style: {
                                wordBreak: "break-word",
                                whiteSpace: "pre-wrap",
                              },
                            }}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </CardContent>
                </Card>
              </Grid>

              {/* Point of Interest Section */}
              <Grid item xs={12} md={6}>
                <Card>
                  <CardContent>
                    <Typography variant="h6">
                      <Star style={{ color: '#2e7d32', marginRight: 6 }} /> Point of Interest
                    </Typography>
                    <Box mt={1} display="flex" flexDirection="column" gap={2}>
                      {selectedData.pointOfInterest.map((step, index) => (
                        <Box
                          key={index}
                          px={2}
                          py={1.5}
                          bgcolor="#e8f5e9"
                          border="1px solid #81c784"
                          borderRadius="16px"
                          maxWidth="100%"
                          sx={{
                            wordBreak: "break-word",
                            whiteSpace: "pre-wrap",
                            overflowWrap: "break-word",
                          }}
                        >
                          <Typography variant="body2" color="textPrimary">
                            {step}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>



            <Card style={{ marginTop: 16 }}>
              <CardContent>
                <Typography variant="h6">
                  <FormatListNumbered /> Steps / Presentation / Procedures
                </Typography>

                <List>
                  {selectedData.stepsAndProcedures.map((step, index) => (
                    <ListItem key={index}>
                      <ListItemIcon>
                        <Typography variant="subtitle1" color="primary">{index + 1}</Typography>
                      </ListItemIcon>
                      <ListItemText primary={step} />
                    </ListItem>
                  ))}
                </List>

                {/* Image Display (if exists) */}

              </CardContent>
            </Card>
            <Card style={{ marginTop: 16 }}>
              <CardContent>
                <Typography variant="h6">Usefull Links</Typography>

                {selectedData.images?.length > 0 && (
                  <Box
                    mt={2}
                    display="flex"
                    flexWrap="wrap"
                    gap={3}
                    justifyContent="center"
                  >
                    {selectedData.images.map((imgUrl, index) => (
                      <Box key={index} textAlign="center">
                        <img
                          src={imgUrl}
                          alt={`Lesson Visual ${index + 1}`}
                          onClick={() => setOpenImage(imgUrl)}
                          style={{
                            maxWidth: '180px',
                            height: 'auto',
                            borderRadius: '8px',
                            border: '1px solid #ccc',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                            margin: '4px',
                            cursor: 'pointer',
                            transition: 'transform 0.2s',
                          }}
                        />
                      </Box>
                    ))}
                  </Box>
                )}
              </CardContent>
            </Card>

            {/* Image Zoom Dialog */}
            <Dialog
              open={Boolean(openImage)}
              onClose={() => setOpenImage(null)}
              maxWidth="md"
              fullWidth
            >
              <DialogContent style={{ position: 'relative', padding: 0 }}>
                <IconButton
                  onClick={() => setOpenImage(null)}
                  style={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    zIndex: 10,
                    backgroundColor: 'rgba(255,255,255,0.8)',
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <img
                  src={openImage}
                  alt="Zoomed"
                  style={{ width: '100%', height: 'auto', display: 'block' }}
                />
              </DialogContent>
            </Dialog>

          </> : ""}

        </Box>
      </Container>

    </>
  );
}
